import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaCar, FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom';



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Empowering your journeys with reliable, affordable, and well-maintained rental cars. Whether it's a business trip or a weekend getaway, we make every ride smooth and stress-free.</p> {/* Description for the about section */}

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaCar className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><FaCar className='icon' /><Link to='/Services'>Services</Link></p>
            <p><FaCar className='icon' /><Link to='/Car-Grid'>Browse Cars</Link></p>
            <p><FaCar className='icon' /><Link to='/Car-Booking'>Rent Cars</Link></p>
            <p><FaCar className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaCar className='icon' /><Link to='/Contact-us'>contact Us</Link></p>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className='footer-item'>
  
          <h2>Contact Info</h2>
  
          <div className='info connect'>
  
            {contactContent
            .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
            .map((contact) => (
                contact.content.map((value, index) => (
                  <div key={index} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{value}</span>
                  </div>
                ))
            ))}
          </div>
  
        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>

          <h2>Newsletter</h2>
          <p>Get the latest car rental deals, travel tips, and exclusive offers delivered straight to your inbox.</p> {/* Description for the Newsletter section */}

          {/* Newsletter component to subscribe */}
          <Newsletter />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; EliteCars 2025 All Rights Reserved</p>
        <p><Link to='/Services-Terms'>Terms of services</Link> | <Link to='/Privacy-Policy'>Privacy Policy</Link></p>

      </div>

    </footer>
  )
}

export default Footer;